import { Component, OnInit } from '@angular/core';
import { ExamService } from 'src/app/services/Exam/exam.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';

@Component({
  selector: 'app-score-card-type',
  templateUrl: './score-card-type.component.html',
  styleUrls: ['./score-card-type.component.css']
})
export class ScoreCardTypeComponent implements OnInit {
  ScoreCardTypeList:any;
  Submitted: boolean = false;
  SelectedFileForUpload:any;

  constructor(private examservice:ExamService,private LookupService: LookupService, public globalHelper: GlobalHelper, 
    private spinnerService: Ng4LoadingSpinnerService) { }

    ScoreCardTypeModel = {

      ExamScoreCardTypeID: '0',
      ExamScoreCardType: '',
      FilePath:''
  }

  
  GetScoreCardType() {
    this.spinnerService.show();
    this.examservice.GetScoreCardType().subscribe((response: any) => {
      this.ScoreCardTypeList = response.ScoreCardTypeList;
      this.spinnerService.hide();
      this.globalHelper.CheckActionStatus(response);
    });
  };

  ngOnInit() {
    this.GetScoreCardType();
  }

}
